export default __webpack_public_path__ + "static/media/790651372537249822.ac76c19a.png";